<template>
  <div id="makuang-queue-card">
    <div class="row mb-5">
      <div class="col-4">
        <img v-if="true" :style="{
          marginLeft: `${logoMarginLeft}px`,
          width: `${logoWidth}px`,
          height: '130px'
        }" :src="this.companyClinicLogo" />
      </div>
      <div class="col-8 d-flex align-items-end justify-content-left">
        <span class="font-weight-bold title">REGISTRATION</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Patient</div>
      <div class="col">: &nbsp; {{ patientName }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase  font-weight-bolder"> Patient IC</div>
      <div class="col">: &nbsp; {{ patientNric }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase  font-weight-bolder"> REG NO</div>
      <div class="col">: &nbsp; {{ visitId }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Vist Clinic</div>
      <div class="col">: &nbsp; {{ clinicName }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Attended by</div>
      <div class="col">: &nbsp; {{ attendedBy }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Queue No</div>
      <div class="col">: &nbsp; {{ queueNumber }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Visit Date</div>
      <div class="col">: &nbsp; {{ registeredDateTime | formatDateTime_DDMMYYYY }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Print Date</div>
      <div class="col">: &nbsp; {{ printDateTime |  formatDateTime_DDMMYYYY }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-3 text-uppercase font-weight-bolder"> Clinic Asst</div>
      <div class="col">: &nbsp; {{ clinicAsst }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import constant from '@/services/constant';
import Dateformatter from '@/components/mixins/dateformatter';
import { createNamespacedHelpers, mapGetters } from 'vuex';
import moment from 'moment';

const { mapGetters: mapQueueGetters } = createNamespacedHelpers('queue');

export default {
  name: 'PrintQueueCardMaKuang',
  mixins: [Dateformatter],
  data() {
    return {
      printLabelConfig: {},
    };
  },
  computed: {
    ...mapGetters('clinic', { allClinics: 'all' }),
    ...mapQueueGetters({
      queueObj: 'queueForPrint',
    }),
    ...mapGetters('config', {
      currentGeneralConfig: 'general',
    }),
    printDate() {
      return moment().format('YYYY/MM/DD HH:mm:ss');
    },
    QUEUE_CALLNUMBER_PREFIX() {
      return constant.QUEUE_CALLNUMBER_PREFIX;
    },
    queueNumber() {
      const { QUEUE_CALLNUMBER_PREFIX, queueObj } = this;
      return `${QUEUE_CALLNUMBER_PREFIX[queueObj.call_number_status]} ${queueObj.call_number}`;
    },
    patientName() {
      return _.chain(this).get('queueObj.patient.name', '').value();
    },
    printDateTime() {
      return moment();
    },
    patientNric() {
      return _.chain(this).get('queueObj.patient.nric', '-').value();
    },
    clinicAsst() {
      return _.chain(this).get('queueObj.addedBy.name', '').value();
    },
    attendedBy() {
      return _.chain(this).get('queueObj.provider.name', '').value() || _.chain(this).get('queueObj.therapist.name', '').value();
    },
    clinicName() {
      const clinic = this.allClinics.find(c => c._id === this.queueObj.clinic);
      return clinic.name;
    },
    logoMarginLeft() {
      return 0;
    },
    companyClinicLogo() {
      return this.currentGeneralConfig.logoURL;
    },
    logoWidth() {
      return 450;
    },
    registerName() {
      return _.chain(this).get('user.name', '').value();
    },
    registeredDateTime() {
      return _.chain(this).get('queueObj.createdAt', '').value();
    },
    visitId() {
      return _.chain(this).get('queueObj.tcmConsultation', '').value();
    },
  },
  methods: {
    triggerPrint() {
      setTimeout(() => {
        window.print();
      }, 3000);
    },
  },
  mounted() {
    this.triggerPrint();
  },
};
</script>


<style lang="scss">
.title {
  font-size: 5mm;
}
#makuang-queue-card {
  margin: 1em;

  background-color: white;

  font-size: 3.5mm;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  padding-top: 0.4em;
  padding-bottom: 0.4em;

  p {
    width: 100%;
    text-align: center;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    font-weight: 300;
  }

  h4 {
    text-align: center;
    margin-top: 0.5rem;
    margin-bottom: 0px;
    font-size: 4mm;
  }

  hr {
    border-top: 2px solid #666;
    margin: 0.5rem;
  }
}
</style>
